import type { LocalizedContent } from "@ebay-business-components/favorites-utils/dist/interface";
import type WatchService from "@ebay-business-components/favorites-utils/dist/services/watch-service-provider";
import type { Locality } from "@ebay/locale-ebay";
import type { PointOfInterest } from "../../@types/mapviewxs";
import { type HorizontalPosition, type PreviewCardPosition, type VerticalPosition, getPreviewCardPosition } from "../../utils/preview-card-position";
import type {
  ItemCardControls,
  MapAccessibilityTexts,
  MarkerSelectionState,
  MarkerWatchState,
  MarkerWithCircle,
  WatchListEntries,
} from "../map/types";

export interface Input {
  selectionState?: MarkerSelectionState;
  watchlistState?: MarkerWatchState;
  animationDelay?: number;
  itemCardControls?: ItemCardControls;
  itemCards?: PointOfInterest[];
  onPreviewClose?: () => void;
  defaultPreviewPosition?: PreviewCardPosition;
  selectedMarker?: MarkerWithCircle | null;
  isPreviewCardEnabled?: boolean;
  mapAccessibilityTexts?: MapAccessibilityTexts;
  locality?: Locality;
  localizedContent?: LocalizedContent;
  watchInstance?: WatchService | null;
  watchListItems?: WatchListEntries;
  handleWatchListItemToggle?: (listingid: string) => void;
}

export interface State {
  previewVerticalPosition?: VerticalPosition | null;
  previewHorizontalPosition?: HorizontalPosition | null;
  itemIndex: number;
}

export default class extends Marko.Component<Input, State> {
  onCreate() {
    this.state = {
      itemIndex: 0,
      previewVerticalPosition: null,
      previewHorizontalPosition: null,
    };
  }

  onRender() {
    if (this.input?.defaultPreviewPosition) {
      const { verticalPosition, horizontalPosition } = this.input.defaultPreviewPosition;
      this.state.previewVerticalPosition = verticalPosition;
      this.state.previewHorizontalPosition = horizontalPosition;
    }
  }

  onInput(input: Input) {
    this.updatePreviewPosition(input, input.selectedMarker?.component.el);
  }

  onUpdate() {
    this.updatePreviewPosition(this.input, this.el);
  }

  updatePreviewPosition(input: Input, markerElement?: Element | void) {
    const isItemSelected = input.selectionState === "selected";
    const mapElement = document.querySelector("#map");
    const previewItemElement = markerElement?.querySelector(".preview-item");

    if (isItemSelected && markerElement && mapElement && previewItemElement && !this.state?.previewVerticalPosition) {
      const { verticalPosition, horizontalPosition } = getPreviewCardPosition(mapElement, markerElement, previewItemElement);
      this.state = {
        itemIndex: 0,
        previewVerticalPosition: verticalPosition,
        previewHorizontalPosition: horizontalPosition,
      };
    } else if (!isItemSelected) {
      this.state = {
        itemIndex: 0,
      };
    }
  }

  onPreviousItem() {
    this.state.itemIndex--;
  }

  onNextItem() {
    this.state.itemIndex++;
  }

  onPreviewClose() {
    this.state.itemIndex = 0;
    this.input.onPreviewClose?.();
  }
}
